import type { WorkStepStatus, WorkOrderStatus } from "@paperclip-cloud/shared";

type Tone = "idle" | "running" | "blocked" | "error";

export interface StatusDotProps {
  tone: Tone;
  pulse?: boolean;
  size?: "sm" | "lg";
  title?: string;
  className?: string;
}

export function StatusDot({ tone, pulse, size = "sm", title, className }: StatusDotProps) {
  return (
    <span
      role={title ? "img" : undefined}
      aria-label={title}
      title={title}
      className={`dot dot--${tone}${size === "lg" ? " dot--lg" : ""}${className ? ` ${className}` : ""}`}
    >
      {pulse && tone === "running" && <span className="dot__ring" aria-hidden="true" />}
    </span>
  );
}

export function deviceTone(d: { online: boolean; current_step_id: string | null; pairing_state: string }): Tone {
  if (d.pairing_state === "revoked") return "error";
  if (!d.online) return "idle";
  if (d.current_step_id) return "running";
  return "idle";
}

export function workStepTone(status: WorkStepStatus): Tone {
  switch (status) {
    case "running":
      return "running";
    case "queued":
      return "blocked";
    case "failed":
      return "error";
    case "cancelled":
      return "idle";
    case "done":
      return "running"; // green
  }
}

export function workOrderTone(status: WorkOrderStatus): Tone {
  switch (status) {
    case "in_progress":
    case "dispatched":
    case "planning":
      return "running";
    case "draft":
      return "idle";
    case "complete":
      return "running";
    case "failed":
      return "error";
    case "cancelled":
      return "idle";
  }
}
